import { z } from 'zod';
import { grade7Schema, severitySchema } from '../../common/schemas/enum.schemas.js';
import { ownerSchema } from '../../common/schemas/owner.schemas.js';
import { inspectionSchema } from '../../estimates/schemas/estimates.schemas.js';
/**
 * One inspection row per owner (plan §3.3). The owner is an estimate today and a stock vehicle from
 * phase 4 — the contract accepts both from the start, because the purchase copies the row across
 * without a second schema (plan §2.3).
 *
 * **Unknown is never Excellent.** Every severity starts `UNKNOWN`, the valuation refuses to price an
 * unknown selection, and the estimator shows "incomplete" instead (PP AC03).
 */
export const getInspectionInputSchema = z.object({
    owner: ownerSchema,
});
export const inspectionOutputSchema = inspectionSchema.nullable();
export const damageIndexSchema = z.number().int().min(0).max(6);
export const updateInspectionInputSchema = z.object({
    owner: ownerSchema,
    grade7: grade7Schema.optional(),
    interior: severitySchema.optional(),
    engine: severitySchema.optional(),
    hybrid: severitySchema.optional(),
    tires: severitySchema.optional(),
    damageGroup1Index: damageIndexSchema.nullish(),
    damageGroup2Index: damageIndexSchema.nullish(),
    inspectorNotes: z.string().trim().max(4_000).nullish(),
});
//# sourceMappingURL=inspections.schemas.js.map